module.exports = __webpack_public_path__ + "img/1.e41480a5.jpg";